import { Fragment, useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { IconButton, Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useEsigningProviderMetadata } from 'app/domains/esigning/hooks/useEsigningProviderMetadata';
import { EsigningProviderAuthenticationModeSlug } from 'shared/domains/apollo/generated/types';
import { EditRecipientEmailDialog } from './EditRecipientEmailDialog';
import { EditRecipientMobileDialog } from './EditRecipientMobileDialog';
import { RemoveRecipientDialog } from './RemoveRecipientDialog';
import { RemoveScriveRecipientDialog } from './RemoveScriveRecipientDialog';
import { RecipientModal } from '../../../../RecipientModal';
var DialogType;
(function (DialogType) {
    /**
     * No dialog is open
     */
    DialogType[DialogType["None"] = 0] = "None";
    /**
     * Edit all fields for the recipient except type
     */
    DialogType[DialogType["Edit"] = 1] = "Edit";
    /**
     * Edit email for the recipient
     */
    DialogType[DialogType["EditEmail"] = 2] = "EditEmail";
    /**
     * Edit mobile number for the recipient
     */
    DialogType[DialogType["EditMobile"] = 3] = "EditMobile";
    /**
     * Remove the recipient
     */
    DialogType[DialogType["RemoveRecipient"] = 4] = "RemoveRecipient";
    /**
     * Remove the recipient for Scrive. We just cancel the sign request
     */
    DialogType[DialogType["RemoveRecipientScrive"] = 5] = "RemoveRecipientScrive";
})(DialogType || (DialogType = {}));
export function PendingActions(props) {
    const { recipient, isOnlyRecipient } = props;
    const { mobile, authenticationMode } = recipient;
    const { properties: providerProperties } = useEsigningProviderMetadata();
    const { canRemoveSignatory, canUseEditPendingSignatory } = providerProperties;
    const [dialogType, setDialogType] = useState(DialogType.None);
    const canEditMobile = authenticationMode === EsigningProviderAuthenticationModeSlug.SmsOtp && Boolean(mobile);
    const closeDialog = () => setDialogType(DialogType.None);
    const handleEdit = () => setDialogType(DialogType.Edit);
    const handleEditEmail = () => setDialogType(DialogType.EditEmail);
    const handleEditMobile = () => setDialogType(DialogType.EditMobile);
    const handleRemoveRecipient = () => setDialogType(canRemoveSignatory ? DialogType.RemoveRecipient : DialogType.RemoveRecipientScrive);
    return (<Fragment>
      {dialogType === DialogType.Edit && <RecipientModal initialValues={recipient} onClose={closeDialog}/>}
      {dialogType === DialogType.EditEmail && <EditRecipientEmailDialog recipient={recipient} onClose={closeDialog}/>}
      {dialogType === DialogType.EditMobile && (<EditRecipientMobileDialog recipient={recipient} onClose={closeDialog}/>)}
      {dialogType === DialogType.RemoveRecipient && (<RemoveRecipientDialog recipient={recipient} onClose={closeDialog}/>)}
      {dialogType === DialogType.RemoveRecipientScrive && <RemoveScriveRecipientDialog onClose={closeDialog}/>}
      <Menu.Root target={<IconButton size="xs" appearance="ghost">
            <Falcon icon="ellipsis-v"/>
          </IconButton>}>
        {canUseEditPendingSignatory ? (<Menu.Item onClick={handleEdit}>
            <Falcon icon="pencil"/>
            <Trans comment="Label for edit eSigning party">Edit party</Trans>
          </Menu.Item>) : (<Fragment>
            <Menu.Item onClick={handleEditEmail}>
              <Falcon icon="envelope"/>
              <Trans comment="Label for edit eSigning party email">Edit email</Trans>
            </Menu.Item>
            {canEditMobile && (<Menu.Item onClick={handleEditMobile}>
                <Falcon icon="phone"/>
                <Trans comment="Label for edit eSigning party mobile">Edit mobile</Trans>
              </Menu.Item>)}
          </Fragment>)}
        {!isOnlyRecipient && (<Menu.Item onClick={handleRemoveRecipient}>
            <Falcon icon="trash"/>
            <Trans comment="Label for withdrawing eSigning party">Withdraw</Trans>
          </Menu.Item>)}
      </Menu.Root>
    </Fragment>);
}
